// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Board = require("../Data.Board/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Extra_Math = require("../Extra.Math/index.js");
var Point = (function () {
    function Point() {

    };
    Point.value = new Point();
    return Point;
})();
var Box = (function () {
    function Box(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Box.create = function (value0) {
        return function (value1) {
            return new Box(value0, value1);
        };
    };
    return Box;
})();
var HealthPickup = (function () {
    function HealthPickup(value0) {
        this.value0 = value0;
    };
    HealthPickup.create = function (value0) {
        return new HealthPickup(value0);
    };
    return HealthPickup;
})();
var Weapon = (function () {
    function Weapon(value0) {
        this.value0 = value0;
    };
    Weapon.create = function (value0) {
        return new Weapon(value0);
    };
    return Weapon;
})();
var Item = function (x) {
    return x;
};
var weak = 1;
var w = function (name) {
    return function (range) {
        return function (shape) {
            return {
                name: name,
                range: range,
                shape: shape
            };
        };
    };
};
var strong = 5;
var pistol = w("pistol")(3)(Point.value);
var medium = 3;
var itemOnSpace = function (v) {
    return function (v1) {
        return Data_Eq.eq(Extra_Math.eqVector(Data_Eq.eqInt))(v)(v1.location);
    };
};
var image = function (v) {
    if (v.tag instanceof HealthPickup) {
        return "heal.png";
    };
    if (v.tag instanceof Weapon) {
        return "weapon.png";
    };
    throw new Error("Failed pattern match at Data.Item (line 23, column 1 - line 23, column 24): " + [ v.constructor.name ]);
};
var allWeapons = [ pistol ];
var affectedSpaces = function (v) {
    return function (v1) {
        if (v1 instanceof Point) {
            return [ v ];
        };
        if (v1 instanceof Box) {
            var v2 = Data_Ring.sub(Extra_Math.ringVector(Data_Ring.ringInt))(v)({
                x: Data_Int.quot(v1.value0)(2),
                y: Data_Int.quot(v1.value1)(2)
            });
            return Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(v2.x)((v1.value0 + v2.x | 0) - 1 | 0))(function (x) {
                return Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(v2.y)((v1.value0 + v2.y | 0) - 1 | 0))(function (y) {
                    return Control_Applicative.pure(Control_Applicative.applicativeArray)({
                        x: x,
                        y: y
                    });
                });
            });
        };
        throw new Error("Failed pattern match at Data.Item (line 60, column 1 - line 60, column 64): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var weaponAttack = function (pos) {
    return function (weapon) {
        return function (health) {
            return Data_Board.injureMulti(affectedSpaces(pos)(weapon))(health);
        };
    };
};
module.exports = {
    Item: Item,
    HealthPickup: HealthPickup,
    Weapon: Weapon,
    image: image,
    strong: strong,
    medium: medium,
    weak: weak,
    itemOnSpace: itemOnSpace,
    w: w,
    pistol: pistol,
    allWeapons: allWeapons,
    Point: Point,
    Box: Box,
    affectedSpaces: affectedSpaces,
    weaponAttack: weaponAttack
};
